// @flow

import React from 'react';
import styled from 'styled-components';
import StyledCartHamburger from './cartHamburger.styled';
import withDrawerColumnToggle from '../../../../../withDrawerColumnToggle';
import type { StateProps, DispatchProps } from '../../../../../withDrawerColumnToggle/types';
import type { Theme } from '../../../../../../types';

type Props = StateProps & DispatchProps;

const Icon = styled<any, Theme>('i')`
  font-size: 1.7rem;
`;

export default withDrawerColumnToggle('cartColumn')(({
  open,
  toggle,
}: Props) => (
  <StyledCartHamburger
    isOpen={open}
    onClick={toggle}
  >
    <Icon className="icon-config_menu" />
  </StyledCartHamburger>
));
